/**
 * Route for `anonymizer-tor-block`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AnonymizerTorBlockPage } from "../features/anonymizer-tor-block/AnonymizerTorBlockPage";

export const anonymizerTorBlockRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/anonymizer-tor-block",
	component: AnonymizerTorBlockPage,
});

export default anonymizerTorBlockRoute;
